<template >
  <div class="big-container">
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div class="container">
      <h1 class="text-titulo">Sobre o sistema </h1>
      <span class="text-span"> {{  descricao ? descricao.sobre : '' }}</span>
      <span style="display: block; font-size: 12px; opacity: 0.6;">Versão 2.2.3</span>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import _axios from '../../plugins/axios';
export default {
  data: () => ({
    overlay: false,
    descricao: null
  }),

  created() {
    this.getSobreSoftline();
  },

  methods: {
    async getSobreSoftline() {
      try {
        this.overlay = true;
        this.descricao = await _axios.get('/getSoftlineDescricao').then((res) =>res.data[0]);
      } catch (error) {
        Swal.fire('Informação', 'Ocoreu um erro durante o carregamento dos dados!', 'info');
      } finally {
        this.overlay = false;
      }
    }

  }
}
</script>

<style scoped>
.big-container {
    height: 100%;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(196, 195, 195, 0.5);
}
.container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
  background-color: #fff;
  border: 0.1px solid #c2c2dd;
  padding: 20px;
  font-size: 12px;
  font-family: sans-serif;
}

.text-titulo {
  font-size: 14px;
}

.text-span {
  display: block;
  text-align: justify;
}

</style>